import { RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export type ResetButtonProps = {
  onReset: () => void;
  label?: string;
  className?: string;
};

export const ResetButton = ({ onReset, label: labelProp, className }: ResetButtonProps) => {
  const { t } = useTranslation("common");
  const label = labelProp ?? t("actions.resetFilters");
  return (
    <button
      type="button"
      onClick={onReset}
      title={label}
      aria-label={label}
      className={cn(
        "flex h-[2.4rem] shrink-0 items-center justify-center pl-2 text-gray-500 transition-colors hover:text-gray-900",
        className,
      )}
    >
      <RotateCcw className="h-5 w-5" />
    </button>
  );
};
